export const ROUTES = {
  HOME: "/",
  EV_SOLUTIONS: "/ev-solutions",
  PRODUCTS: "/products",
  SUPPORT: "/support",
  ABOUT: "/about",
  HELP_USER_GUIDE: "/help/user-guide",
  HELP_VIDEO_TUTORIALS: "/help/video-tutorials",
  HELP_COMMUNITY_FORUM: "/help/community-forum",
  DOWNLOAD_APP: "/download-app",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
};

/**
 * Navigation Items for Navbar
 */
export const NAV_ITEMS = [
  { name: "Home", path: ROUTES.HOME, translationKey: "home" },
  { name: "About", path: ROUTES.ABOUT, translationKey: "about" },
  {
    name: "EV Solutions",
    path: ROUTES.EV_SOLUTIONS,
    translationKey: "evSolutions",
  },
  { name: "Products", path: ROUTES.PRODUCTS, translationKey: "products" },
  { name: "Support", path: ROUTES.SUPPORT, translationKey: "support" },
];
